import { render, staticRenderFns } from "./SearchGroup.vue?vue&type=template&id=65dde6f7&"
import script from "./SearchGroup.vue?vue&type=script&lang=ts&"
export * from "./SearchGroup.vue?vue&type=script&lang=ts&"
import style0 from "./SearchGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports